import apiClient from './config';

export default {
  // Récupérer le statut de l'abonnement
  getSubscriptionStatus() {
    return apiClient.get('/subscription/status');
  },

  // Créer une session du portail client Stripe
  createPortalSession() {
    return apiClient.post('/subscription/create-portal-session');
  },

  // SMS Credits
  // Récupérer le solde de crédits SMS
  getSmsBalance() {
    return apiClient.get('/firm/sms-credits/balance');
  },

  // Acheter des crédits SMS
  purchaseSmsCredits(packageType) {
    return apiClient.post('/firm/sms-credits/purchase', { package: packageType });
  },

  // Vérifier un achat de crédits SMS
  verifySmsPurchase(sessionId) {
    return apiClient.post('/firm/sms-credits/verify-purchase', { sessionId });
  },

  // Récupérer l'historique des crédits SMS
  getSmsHistory() {
    return apiClient.get('/firm/sms-credits/history');
  },

  // Configurer la recharge automatique
  updateAutoRecharge(autoRecharge, autoRechargeAmount, autoRechargePackage) {
    return apiClient.put('/firm/sms-credits/auto-recharge', {
      autoRecharge,
      autoRechargeAmount,
      autoRechargePackage
    });
  },

  // Récupérer les paramètres de recharge automatique
  getAutoRechargeSettings() {
    return apiClient.get('/firm/sms-credits/auto-recharge');
  },

  // Abonnements
  // Créer une session Stripe Checkout pour un plan
  createCheckoutSession(planType) {
    return apiClient.post('/subscription/create-checkout', { planType });
  },

  // Récupérer le palier lifetime selon le type de plan
  getLifetimeTier(planType) {
    return apiClient.get('/subscription/lifetime-tier', { params: { planType } });
  },

  // Vérifier et activer l'abonnement après paiement
  verifySubscription(sessionId) {
    return apiClient.post('/subscription/verify', { sessionId });
  },
};
